// Loading.js
import React from "react";
import { CircularProgress, Box, Typography } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#2979ff", // A nice blue color
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

export function Loading() {
  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh", // Occupy full viewport height
          bgcolor: "#f5f5f5", // Light grey background
        }}
      >
        <CircularProgress size={60} color="primary" sx={{ mb: 2 }} />
        <Typography variant="h6" color="textSecondary">
          Loading...
        </Typography>
      </Box>
    </ThemeProvider>
  );
}
